export class MapInfo {
    timeZoneId?: string;
    country?: string;
    city?: string;
    lat?: number;
    lng?: number;
    formatted_address?: string;
}

export interface InterfaceLocation {
    lat: number,
    long: number
}